module.exports = __webpack_public_path__ + "public/1.0.1_626420/img/79.27f32793.png";